import React, { useState, useEffect } from "react";
import {
  PhoneIcon,
  PlayIcon,
  StopIcon,
  BellIcon,
} from "@heroicons/react/24/outline";
import {
  startPhoneroWebSocket,
  stopPhoneroWebSocket,
} from "../../../api/company";
import {
  Button,
  Card,
  Typography,
  Alert,
  Box,
  CircularProgress,
} from "@mui/material";
import PlayArrow from "@mui/icons-material/PlayArrow";
import Stop from "@mui/icons-material/Stop";
import Refresh from "@mui/icons-material/Refresh";

const WebSocketManager = ({ companyId }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState("disconnected");
  const [recentCalls, setRecentCalls] = useState([]);

  // WebSocket functionality temporarily disabled
  const isWebSocketDisabled = true;

  const handleStartWebSocket = async () => {
    // WebSocket functionality temporarily disabled
    return;
  };

  const handleStopWebSocket = async () => {
    // WebSocket functionality temporarily disabled
    return;
  };

  const getStatusColor = () => {
    return "info";
  };

  const getStatusText = () => {
    return "WebSocket functionality temporarily disabled";
  };

  return (
    <Card sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Real-time Call Monitoring
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Connect to Telia SmartConnect WebSocket API to receive real-time call
        events. This will automatically create communication records for
        incoming calls.
      </Typography>

      <Alert severity="info" sx={{ mb: 2 }}>
        <Typography variant="body2">
          WebSocket functionality is temporarily disabled while we work on other
          features. You can still monitor calls using the call history feature.
        </Typography>
      </Alert>

      <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
        <Alert severity={getStatusColor()} sx={{ flex: 1 }}>
          {getStatusText()}
        </Alert>
      </Box>

      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<PlayArrow />}
          onClick={handleStartWebSocket}
          disabled={true}
        >
          Start WebSocket
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          startIcon={<Stop />}
          onClick={handleStopWebSocket}
          disabled={true}
        >
          Stop WebSocket
        </Button>

        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={handleStartWebSocket}
          disabled={true}
        >
          Retry Connection
        </Button>
      </Box>

      <Alert severity="info" sx={{ mt: 2 }}>
        <Typography variant="body2">
          The system will continue to work with manual call log fetching.
          WebSocket functionality will be re-enabled in a future update.
        </Typography>
      </Alert>

      {status === "failed" && (
        <Alert severity="info" sx={{ mt: 2 }}>
          <Typography variant="body2">
            If WebSocket is not supported, you can still monitor calls using the
            call history feature. The system will continue to work with manual
            call log fetching.
          </Typography>
        </Alert>
      )}

      {isConnected && (
        <div className="mt-6">
          <h4 className="text-sm font-medium text-gray-900 mb-3">
            Recent Real-time Calls
          </h4>
          {recentCalls.length === 0 ? (
            <div className="text-center py-4">
              <PhoneIcon className="mx-auto h-8 w-8 text-gray-400" />
              <p className="mt-2 text-sm text-gray-500">
                Waiting for incoming calls...
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {recentCalls.map((call, index) => (
                <div
                  key={index}
                  className="flex items-center p-3 bg-gray-50 rounded-md"
                >
                  <div className="flex-shrink-0">
                    <PhoneIcon className="h-5 w-5 text-green-600" />
                  </div>
                  <div className="ml-3 flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      {call.from_number}
                    </p>
                    <p className="text-sm text-gray-500">
                      {call.event_type} - {call.timestamp}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

export default WebSocketManager;
